import { render, staticRenderFns } from "./save-terminal-block-dialog.component.vue?vue&type=template&id=1fada9cb&scoped=true"
import script from "./save-terminal-block-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-terminal-block-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./save-terminal-block-dialog.component.vue?vue&type=style&index=0&id=1fada9cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fada9cb",
  null
  
)

export default component.exports